/**
 * 新增用户
 */
import React from 'react';
import {Col, Input, Modal, Radio, Row, Select, Cascader, Icon, Upload, Button} from "antd";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";
import "./addUser.css";
import BaseComponent from "../../../base/BaseComponent";
import {cityData} from "./cityData";
import {ONLY_PIC_TYPE_NEW} from "../../../constants";

const {Option} = Select;
const {TextArea} = Input;

export default class AddUser extends BaseComponent {
    static propTypes = {};
    static defaultProps = {
        showAllDept: false
    };

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            title: "",
            addDataObj: {},
            treeDataIndex: {
                key: "id",
                value: "id",
                label: "name",
                children: "child",
            },
            treeData: [],
            loading: false,
            onlyView: false,
            strLength: 0
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDeptTree();
    }

    show(record) {
        if (record) {
            this.request({
                url: "/cm-sites-mmp/rmUser/findById",
                method: "post",
                body: {rmUserId: record.id},
                callBack: (res) => {
                    const addFields = this.getAddFields();
                    let addDataObj = {};
                    addDataObj.id = res.id;
                    addFields.forEach(item => {
                        if (res[item.field]) {
                            addDataObj[item.field] = res[item.field]
                        }
                    })
                    if(addDataObj.deptIds&&addDataObj.deptIds[0]&&addDataObj.deptIds[0]==0){
                       addDataObj.deptIds.shift()
                    }
                    if (res) {
                        this.setState({
                            visible: true,
                            title: "编辑用户",
                            addDataObj
                        })
                    }
                }
            });
        } else {
            this.setState({
                visible: true,
                title: "新增用户",
                addDataObj: {
                    status: 1, //默认为启用
                    sex: 1
                }
            })
        }
    }

    getDeptTree() {
        this.request({
            url: "/cm-sites-sys/dept/getTree",
            body: {id: 0},
            callBack: (res) => {
                // let data = [res];
                let data = res.child;
                if (!this.props.showAllDept && res[this.state.treeDataIndex["children"]] && res[this.state.treeDataIndex["children"]].length > 0) {
                    data = res[this.state.treeDataIndex["children"]];
                }
                // 格式化树数据
                const treeData = this.getTreeData(data, this.state.treeDataIndex);
                this.setState({
                    treeData
                });
            }
        });
    }

    getTreeData(treeData, treeDataIndex) {
        const newTreeData = [];
        for (let i = 0; i < treeData.length; i++) {
            const treeNode = treeData[i];
            let item = {
                value: treeNode[treeDataIndex["value"]],
                label: treeNode[treeDataIndex["label"]],
                key: treeNode[treeDataIndex["key"]],
                data: treeNode
            };
            treeNode[treeDataIndex["children"]] && treeNode[treeDataIndex["children"]].length > 0 && (item.children = this.getTreeData(treeNode[treeDataIndex["children"]], treeDataIndex));
            newTreeData.push(item);
        }
        return newTreeData;
    }


    /**
     * 新增字段
     * type 1  输入框
     * type 2  Select选择框
     * type 3  Cascader级联选择框
     * type 4  单选框
     */
    getAddFields() {
        return (
            [
                {
                    key: "account",
                    field: "account",
                    title: "手机号",
                    type: "1",
                    isRequired: true,
                    disabled: true
                },
                {
                    key: "region",
                    field: "region",
                    title: "所在地区",
                    type: "4"
                },
                {
                    key: "nickName",
                    field: "nickName",
                    title: "用户昵称",
                    maxLength: 10,
                    type: "1",
                    isRequired: true,
                },
                {
                    key: "userType",
                    field: "type",
                    title: "用户类型",
                    type: "2",
                    isRequired: true,
                    options: [
                        {
                            key: "1",
                            value: 1,
                            title: "外部人员"
                        },
                        {
                            key: "2",
                            value: 2,
                            title: "内部人员"
                        },
                        {
                            key: "3",
                            value: 3,
                            title: "内部管理"
                        },
                    ]
                },
                {
                    key: "dept",
                    field: "deptIds",
                    title: "所属单位",
                    type: this.state.addDataObj["type"] === 1 ? "" : "4",
                    isRequired: this.state.addDataObj["type"] !== 1,
                },
                {
                    key: "sex",
                    field: "sex",
                    title: "性别",
                    type: "3",
                    isRequired: true,
                    options: [
                        {
                            key: "1",
                            value: 1,
                            title: "男"
                        },
                        {
                            key: "2",
                            value: 2,
                            title: "女"
                        }
                    ]
                },
                {
                    key: "status",
                    field: "status",
                    title: "用户状态",
                    type: "3",
                    isRequired: true,
                    options: [
                        {
                            key: "1",
                            value: 1,
                            title: "启用"
                        },
                        {
                            key: "2",
                            value: 2,
                            title: "禁用"
                        }
                    ]
                },
            ]
        )
    }

    fieldChange(field, value) {
        this.state.addDataObj[field] = value || undefined;
        if (field === "type" && value === 1 && this.state.addDataObj["deptIds"]) {
            delete this.state.addDataObj.deptIds
        }
        this.setState({});
    }

    saveData() {
        //校验
        if (!this.checkForm()) return false;
        let params = {
            ...this.state.addDataObj
        };
        if (this.state.addDataObj.id) {
            params.id = this.state.addDataObj.id;
        }
        this.request({
            url: "/cm-sites-mmp/rmUser/add",
            body: params,
            method: "post",
            contentType: "json",
            callBack: (res) => {
                if (res) {
                    message.success("提交成功");
                    this.setState({
                        visible: false,
                    })
                    this.props.refreshList();
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    }

    checkForm = () => {
        const addFields = this.getAddFields();
        let reg = new RegExp("^[1][3-9][0-9]{9}$")
        for (let i = 0; i < addFields.length; i++) {
            let item = addFields[i];
            if (item.isRequired && !this.state.addDataObj[item.field]) {
                message.info("请检查必填项！");
                return false;
            }
            if (item.field === "account" && !reg.test(this.state.addDataObj[item.field])) {
                message.info("手机号格式不正确！");
                return false;
            }
        }
        return true;
    }

    showTreeData(item) {
        let treeData = this.state.treeData;
        if (item.field === "region") {
            treeData = cityData;
        }
        return treeData;
    }

    renderUpload(item) {
        const uploadButton = (
            <div>
                <div style={{marginTop: 8}}><Icon type={this.state.loading ? "loading" : "plus"}/></div>
            </div>
        );
        return (
            <Upload
                accept={"." + ONLY_PIC_TYPE_NEW.join(",.")}
                name="file"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action="/storage/uploadFile"
                beforeUpload={(file) => {
                    const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/bmp' || file.type === 'image/png';
                    if (!isJpgOrPng) {
                        message.error('暂不支持该文件类型！');
                    }
                    const isLt2M = file.size / 1024 / 1024 < 20;
                    if (!isLt2M) {
                        message.error('图片大小必须小于20MB！');
                    }
                    return isJpgOrPng && isLt2M;
                }}
                onChange={(info) => this.handleChange(info, item)}
            >
                {this.state.addDataObj[item.field] ?
                    <img src={this.state.addDataObj[item.field]} alt="avatar" style={{width: '100%'}}/> : uploadButton}
            </Upload>
        );
    }

    handleChange(info, item) {
        if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;
        }
        if (info.file.status === 'done') {
            this.state.addDataObj[item.field] = info.file.response.data.path;
            this.setState({
                loading: false
            });
        }
    };

    render() {
        const {visible, title, onlyView} = this.state;
        const addFields = this.getAddFields();
        return (
            <Modal
                title={title}
                visible={visible}
                width={600}
                onCancel={() => {
                    this.setState({
                        visible: false
                    })
                }}
                footer={
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Button onClick={() => {
                            this.setState({
                                visible: false
                            })
                        }}>{onlyView ? "关闭" : "取消"}</Button>
                        {onlyView ? null : <Button type={"primary"} onClick={() => {
                            this.saveData()
                        }}>提交</Button>}
                    </div>
                }
                okText={"提交"}
                maskClosable={false}
                centered
            >
                <div>
                    {
                        addFields.length > 0 && addFields.map((item, index) => {
                            let treeData = this.showTreeData(item);
                            return (
                                (() => {
                                    switch (item.type) {
                                        case "1" :
                                            return <Row key={item.key}>
                                                <div style={{padding: 10}}>
                                                    <Col span={5}>
                                                        <div className={'addUserTitle'}>{item.isRequired ? <span
                                                            style={{color: 'red'}}>*</span> : null}{item.title}：
                                                        </div>
                                                    </Col>
                                                    <Col span={19}>
                                                        <Input
                                                            placeholder={item.maxLength ? `请输入${item.title}，最多${item.maxLength}个字` : `请输入${item.title}`}
                                                            disabled={!!(item.disabled && this.state.addDataObj.id)}
                                                            className={'addUserContent'}
                                                            value={this.state.addDataObj[item.field]}
                                                            maxLength={item.maxLength || null}
                                                            onChange={(e) => {
                                                                this.fieldChange(item.field, e.target.value)
                                                            }}/>
                                                    </Col>
                                                </div>
                                            </Row>
                                        case "2":
                                            return <Row key={item.key}>
                                                <div style={{padding: 10}}>
                                                    <Col span={5}>
                                                        <div className={'addUserTitle'}>{item.isRequired ? <span
                                                            style={{color: 'red'}}>*</span> : null}{item.title}：
                                                        </div>
                                                    </Col>
                                                    <Col span={19}>
                                                        <Select
                                                            placeholder={`请选择${item.title}`}
                                                            allowClear
                                                            disabled={!!(item.disabled && this.state.addDataObj.id)}
                                                            className={'addUserContent'}
                                                            value={this.state.addDataObj[item.field]}
                                                            onChange={(value) => {
                                                                this.fieldChange(item.field, value)
                                                            }}>
                                                            {item.options.length > 0 && item.options.map(i => {
                                                                return <Option key={i.key}
                                                                               value={i.value}>{i.title}</Option>
                                                            })}
                                                        </Select>
                                                        <style>{`.addUserContent .ant-select-selection{border: 1px solid #EEF2FB; background-color: rgba(246, 248, 253, 0.39);}`}</style>
                                                    </Col>
                                                </div>
                                            </Row>
                                        case "3" :
                                            return <Row key={item.key}>
                                                <div style={{padding: 10}}>
                                                    <Col span={5}>
                                                        <div className={'addUserTitle'}>{item.isRequired ? <span
                                                            style={{color: 'red'}}>*</span> : null}{item.title}：
                                                        </div>
                                                    </Col>
                                                    <Col span={19}>
                                                        <Radio.Group style={{lineHeight: "37px"}}
                                                                     disabled={!!(item.disabled && this.state.addDataObj.id)}
                                                                     value={this.state.addDataObj[item.field]}
                                                                     onChange={(e) => {
                                                                         this.fieldChange(item.field, e.target.value)
                                                                     }}>
                                                            {item.options.length > 0 && item.options.map(i => {
                                                                return <Radio style={{marginRight: 30}} key={i.key}
                                                                              value={i.value}>{i.title}</Radio>
                                                            })}
                                                        </Radio.Group>
                                                    </Col>
                                                </div>
                                            </Row>
                                        case "4" :
                                            return <Row key={item.key}>
                                                <div style={{padding: 10}}>
                                                    <Col span={5}>
                                                        <div className={'addUserTitle'}>{item.isRequired ? <span
                                                            style={{color: 'red'}}>*</span> : null}{item.title}：
                                                        </div>
                                                    </Col>
                                                    <Col span={19}>
                                                        <Cascader className={'addUserContent'}
                                                                  disabled={!!(item.disabled && this.state.addDataObj.id)}
                                                                  placeholder={`请选择${item.title}`}
                                                                  value={this.state.addDataObj[item.field]}
                                                                  options={treeData} onChange={(value) => {
                                                            this.fieldChange(item.field, value)
                                                        }} changeOnSelect/>
                                                        <style>{`
                                                            .ant-cascader-menu-item-expand{
                                                                position: relative;
                                                                padding-right: 42px;
                                                            }
                                                        `}</style>
                                                    </Col>
                                                </div>
                                            </Row>
                                        case "5" :
                                            return <Row key={item.key}>
                                                <div style={{padding: 10}}>
                                                    <Col span={5}>
                                                        <div className={'addUserTitle'}>{item.isRequired ? <span
                                                            style={{color: 'red'}}>*</span> : null}{item.title}：
                                                        </div>
                                                    </Col>
                                                    <Col span={19}>
                                                        {this.renderUpload(item)}
                                                    </Col>
                                                </div>
                                            </Row>
                                        case "6" :
                                            return <Row key={item.key}>
                                                <div style={{padding: 10}} id={"textarea"}>
                                                    <Col span={5}>
                                                        <div className={'addUserTitle'}>{item.isRequired ? <span
                                                            style={{color: 'red'}}>*</span> : null}{item.title}：
                                                        </div>
                                                    </Col>
                                                    <Col span={19}>
                                                        <TextArea rows={item.rows ? item.rows : 4}
                                                                  placeholder={item.maxLength ? `请输入${item.title}，最多${item.maxLength}个字` : `请输入${item.title}`}
                                                                  disabled={!!(item.disabled && this.state.addDataObj.id)}
                                                                  className={'addUserContent'}
                                                                  value={this.state.addDataObj[item.field]}
                                                                  maxLength={item.maxLength || null}
                                                                  onChange={(e) => {
                                                                      this.state.strLength = e.target.value.length;
                                                                      this.fieldChange(item.field, e.target.value)
                                                                  }}/>
                                                        {item.showStrLength ?
                                                            <div style={{textAlign: "right", marginRight: 50}}>
                                                                已输入<span style={{marginLeft: 5}}>{this.state.strLength}</span>/{item.maxLength}
                                                            </div> : null}
                                                        <style>{`#textarea textarea.ant-input {resize: none;}`}</style>
                                                    </Col>
                                                </div>
                                            </Row>
                                        default:
                                            return null
                                    }
                                })()
                            )
                        })
                    }
                    <style>{`.ant-input{border: 1px solid #EEF2FB;}`}</style>
                </div>
            </Modal>
        )
    }
}